module.exports = __webpack_public_path__ + "img/left-arrow.f722c6cc.svg";